import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { Coins, Check, ChevronDown } from "lucide-react";
import { useCurrency } from "@/context/CurrencyContext";

export const CurrencySwitcher = ({ variant = "navbar" }) => {
  const { code, currencies, setCurrency } = useCurrency();

  if (variant === "mobile") {
    return (
      <div className="grid grid-cols-3 gap-2" data-testid="currency-switcher-mobile">
        {currencies.map((c) => (
          <button
            key={c.code}
            onClick={() => setCurrency(c.code)}
            data-testid={`currency-option-${c.code}`}
            className={`h-11 rounded-lg border text-sm font-semibold transition-colors ${
              code === c.code
                ? "border-orange-500 bg-orange-50 text-orange-600"
                : "border-slate-200 text-slate-600 hover:border-slate-300"
            }`}
          >
            {c.code}
          </button>
        ))}
      </div>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="flex items-center gap-1.5 px-2 text-slate-600 hover:text-orange-500"
          data-testid="currency-switcher-trigger"
        >
          <Coins className="w-4 h-4" />
          <span className="text-sm font-semibold">{code}</span>
          <ChevronDown className="w-3.5 h-3.5 opacity-60" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuLabel className="text-xs text-slate-400 font-normal">
          Display currency
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {currencies.map((c) => (
          <DropdownMenuItem
            key={c.code}
            onClick={() => setCurrency(c.code)}
            className="flex items-center justify-between cursor-pointer"
            data-testid={`currency-option-${c.code}`}
          >
            <span>{c.label}</span>
            {code === c.code && <Check className="w-4 h-4 text-orange-500" />}
          </DropdownMenuItem>
        ))}
        <DropdownMenuSeparator />
        <p className="px-2 py-1 text-[10px] leading-tight text-slate-400">
          Live rates via exchangerate-api.com. Billing is processed in XCD.
        </p>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default CurrencySwitcher;
